module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "right menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "red item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addVoucher($event)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v(" Add Voucher")])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v("\n      Vouchers\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui loader",
    class: {
      'active': _vm.fetching
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ui table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.vouchers), function(voucher) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(voucher.code))]), _vm._v(" "), _c('td', [_vm._v("Relative: "), _c('strong', [_vm._v("-" + _vm._s(voucher.deduct.percentage * 100) + "%")]), _vm._v(", Absolute: "), _c('strong', [_vm._v("-" + _vm._s(voucher.deduct.absolute) + "€")])]), _vm._v(" "), _c('td', [_vm._v("Min Total: "), _c('strong', [_vm._v(_vm._s(voucher.min.absolute) + "€")]), _vm._v(", Min Hours: "), _c('strong', [_vm._v(_vm._s(voucher.min.hours))])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui tiny buttons"
    }, [_c('div', {
      staticClass: "ui button",
      on: {
        "click": function($event) {
          _vm.editVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Voucher")]), _vm._v(" "), _c('div', {
      staticClass: "ui floating dropdown blue icon button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('i', {
      staticClass: "dropdown icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.editVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "edit icon"
    }), _vm._v(" Edit Voucher")]), _vm._v(" "), _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.triggerDeleteVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "trash icon"
    }), _vm._v(" Delete Voucher")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ui small basic delete modal"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      Delete voucher "), (_vm.voucherForDelete) ? _c('strong', [_vm._v(_vm._s(_vm.voucherForDelete.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui green ok inverted button",
    on: {
      "click": function($event) {
        _vm.deleteVoucher(_vm.voucherForDelete)
      }
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n        Yes\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "voucherModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.voucher._id) ? _c('span', [_vm._v("Edit Voucher")]) : _c('span', [_vm._v("Add Voucher")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.code),
      expression: "voucher.code"
    }],
    staticClass: "ui input",
    domProps: {
      "value": (_vm.voucher.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Deduct %")]), _vm._v(" "), _c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.deduct.percentage),
      expression: "voucher.deduct.percentage"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.deduct.percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.deduct.percentage = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Deduct Absolute")]), _vm._v(" "), _c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.deduct.absolute),
      expression: "voucher.deduct.absolute"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.deduct.absolute)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.deduct.absolute = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("€")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui two fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Minimum Price")]), _vm._v(" "), _c('div', {
    staticClass: "ui right labeled input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.min.absolute),
      expression: "voucher.min.absolute"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.min.absolute)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.min.absolute = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("€")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("Minimum Hours")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.min.hours),
      expression: "voucher.min.hours"
    }],
    staticClass: "ui input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.voucher.min.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.min.hours = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui icon positive button",
    on: {
      "click": _vm.saveVoucher
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save Voucher\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n          Code\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Deduct\n        ")]), _vm._v(" "), _c('th', [_vm._v("\n          Conditions\n        ")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("\n          Actions\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui red basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n        No\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon cancel button"
  }, [_c('i', {
    staticClass: "delete icon"
  }), _vm._v(" Close\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4cb8046"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Vouchers.vue
// module id = 750
// module chunks = 1